import { Spacing } from '../Spacing'

/**
 * Standardized sizes used in the Gem Design System. All values are defined
 * relative to `Spacing` `XS`.
 *
 * @note See `Spacing` for generic spacing.
 */
export const enum Size {
  /**
   * The standard height (`block-size`) for controls and input elements.
   */
  ControlHeight = Spacing.XS * 8,
  /**
   * The rendered size of most Gem icons.
   */
  Icon = Spacing.XS * 4,
  /**
   * The standard `border-radius` for interface elements. All `border-radius`
   * values should be relative to `Rounding`.
   *
   * @example
   * borderRadius: Size.Rounding,
   * @example
   * borderRadius: Size.Rounding * 1.5,
   * @example
   * borderStartEndRadius: Size.Rounding,
   *
   * @deprecated Switch to `@opallabs/gem` `CornerRadius`
   */
  Rounding = Spacing.XS,
  /**
   * The rendered size of Gem icons when used with small Lapidary `<Button>`s.
   */
  SmallIcon = Spacing.XS * 3,
  /**
   * The standard diameter (`block-size` and `inline-size`) of status
   * indicators — for example, marking that an input’s value is invalid.
   */
  StatusIndicator = Spacing.XS * 2.25,
}
